import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { NavLink } from 'react-router-dom';

import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';

const inlineStyles = theme => ({
  breadcrumbContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '10px',
    marginBottom: '20px',
    marginLeft: '10px',
    marginRight: '10px',
  },
  breadcrumbButton: {
    borderBottom: '4px solid',
    borderBottomColor: 'rgba(0, 0, 0, 0.26)',
    margin: '2px',
    color: theme.palette.primary.main,
    textTransform: 'capitalize',
    flexGrow: 1,
    fontSize: '13px',
    lineHeight: '20px',
    fontWeight: 400,
  },
  buttonCurrentPhase: {
    borderBottomColor: theme.palette.primary.main,
    fontWeight: 700,
  },
  buttonPhaseReady: {
    borderBottomColor: '#207028',
    textDecoration: 'underline',
  },
  lastPhase: {
    '& > a': {
      textDecoration: 'none',
      '&:last-of-type': {
        borderBottomColor: '#207028',
        color: '#207028 !important',
      },
    },
  },
});

/**
 * Breadcrumb
 * Use to show information of selected service
 * @param {Object} classes          Classes from JSS inlineStyles
 * @param {string} lang             CurrentLang
 * @param {number} currenttabindex  Current tab-index
 */

const Breadcrumb = ({ classes, t, lang, currenttabindex, subServiceUrlFragment }) => {
  const phases = [
    {
      title: t('views.breadcrumb.service'),
      link: `/${lang}`,
    },
    {
      title: t('views.breadcrumb.time'),
      link: `/${lang}/${subServiceUrlFragment}`,
    },
    {
      title: t('views.breadcrumb.details'),
      link: `/${lang}/details`,
    },
    {
      title: t('views.breadcrumb.ready'),
      link: `/${lang}/confirmed`,
    },
  ];

  return (
    <Grid
      item
      xs={12}
      className={`${classes.breadcrumbContainer} ${currenttabindex === phases.length && classes.lastPhase}`}>
      {phases.map((phase, index) => (
        <Button
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          disableRipple
          className={`${classes.breadcrumbButton} ${currenttabindex === index + 1 && classes.buttonCurrentPhase} ${
            currenttabindex > index + 1 && classes.buttonPhaseReady
          }`}
          component={NavLink}
          to={phase.link}
          disabled={currenttabindex < index + 1 || phases.length === currenttabindex}>
          {phase.title}
        </Button>
      ))}
    </Grid>
  );
};

Breadcrumb.propTypes = {
  classes: PropTypes.object,
  currenttabindex: PropTypes.number,
  lang: PropTypes.string,
  subServiceUrlFragment: PropTypes.string,
  t: PropTypes.func,
};
Breadcrumb.defaultProps = {
  classes: {},
  currenttabindex: 1,
  lang: '',
  subServiceUrlFragment: '',
  t: null,
};

export default withStyles(inlineStyles)(withTranslation('translations')(Breadcrumb));
